import { useCountries } from "../context/CountryContext";

export default function CountrySelect({
  value,
  onChange,
  required = false,
  className = "",
}) {
  const { countries } = useCountries();
  return (
    <select
      required={required}
      value={value}
      onChange={(e) => onChange(e.target.value)}
      className={
        className ||
        "w-full px-4 py-3 rounded-xl border border-[#c4c6d1] focus:ring-2 focus:ring-[#00255a]/10 outline-none"
      }
    >
      <option value="">Select country…</option>
      {countries.map((country) => (
        <option key={country.country} value={country.country}>
          {country.country}
        </option>
      ))}
    </select>
  );
}
